'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reselect = require('reselect');

var _richMediaSelector = require('./richMediaSelector');

var _richMediaActions = require('./richMediaActions');

var _richMediaConstants = require('./richMediaConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib


// Selectors


// Actions


// Constants


var mapStateToProps = (0, _reselect.createSelector)(function (state, ownProps) {
    return ownProps.element.get('id');
}, _richMediaSelector.getRichMediaState, function (id, richMediaState) {
    var contentState = (0, _richMediaSelector.getRichMediaContentState)(id, richMediaState);
    var embeddingRichMedia = contentState === _richMediaConstants.RICH_MEDIA_STATE.EMBEDDING;
    var showRichMedia = embeddingRichMedia || contentState === _richMediaConstants.RICH_MEDIA_STATE.READY;
    var showError = contentState === _richMediaConstants.RICH_MEDIA_STATE.ERROR;
    var showPreview = !contentState || contentState === _richMediaConstants.RICH_MEDIA_STATE.PREVIEW || embeddingRichMedia || showError;

    return {
        contentState: contentState,
        showPreview: showPreview,
        embeddingRichMedia: embeddingRichMedia,
        showRichMedia: showRichMedia,
        showError: showError
    };
});

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        dispatchRichMediaEmbedding: function dispatchRichMediaEmbedding(id) {
            return dispatch((0, _richMediaActions.richMediaEmbedding)(id));
        },
        dispatchRichMediaReady: function dispatchRichMediaReady(id) {
            return dispatch((0, _richMediaActions.richMediaReady)(id));
        },
        dispatchRichMediaError: function dispatchRichMediaError(id) {
            return dispatch((0, _richMediaActions.richMediaError)(id));
        },
        dispatchRichMediaReturnToPreview: function dispatchRichMediaReturnToPreview(id) {
            return dispatch((0, _richMediaActions.richMediaReturnToPreview)(id));
        }
    };
};

exports.default = function (DecoratedComponent) {
    var _dec, _class;

    var richMediaConnectDecorator = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_React$Component) {
        _inherits(richMediaConnectDecorator, _React$Component);

        function richMediaConnectDecorator() {
            var _ref;

            var _temp, _this, _ret;

            _classCallCheck(this, richMediaConnectDecorator);

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = richMediaConnectDecorator.__proto__ || Object.getPrototypeOf(richMediaConnectDecorator)).call.apply(_ref, [this].concat(args))), _this), _this.dispatchRichMediaEmbedding = function () {
                return _this.dispatchMediaUpdateFn(_this.props.dispatchRichMediaEmbedding);
            }, _this.dispatchRichMediaReady = function () {
                return _this.dispatchMediaUpdateFn(_this.props.dispatchRichMediaReady);
            }, _this.dispatchRichMediaError = function () {
                return _this.dispatchMediaUpdateFn(_this.props.dispatchRichMediaError);
            }, _this.dispatchRichMediaReturnToPreview = function () {
                return _this.dispatchMediaUpdateFn(_this.props.dispatchRichMediaReturnToPreview);
            }, _this.dispatchMediaUpdateFn = function (fn) {
                var element = _this.props.element;

                var id = element.get('id');
                return fn(id);
            }, _temp), _possibleConstructorReturn(_this, _ret);
        }

        _createClass(richMediaConnectDecorator, [{
            key: 'render',
            value: function render() {
                return _react2.default.createElement(DecoratedComponent, _extends({}, this.props, {
                    dispatchRichMediaEmbedding: this.dispatchRichMediaEmbedding,
                    dispatchRichMediaReady: this.dispatchRichMediaReady,
                    dispatchRichMediaError: this.dispatchRichMediaError,
                    dispatchRichMediaReturnToPreview: this.dispatchRichMediaReturnToPreview }));
            }
        }]);

        return richMediaConnectDecorator;
    }(_react2.default.Component)) || _class);


    richMediaConnectDecorator.propTypes = {
        element: _propTypes2.default.object.isRequired,
        showPreview: _propTypes2.default.bool,
        dispatchRichMediaEmbedding: _propTypes2.default.func,
        dispatchRichMediaReady: _propTypes2.default.func,
        dispatchRichMediaError: _propTypes2.default.func,
        dispatchRichMediaReturnToPreview: _propTypes2.default.func
    };

    return richMediaConnectDecorator;
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/richMedia/richMediaConnectDecorator.js
// module id = 2020
// module chunks = 0